/**
 * MRPH Product Versions
 *
 * Defines the activity data configuration to use for MRPH product.
 */

import { TechnicalError } from '@orus.eu/error'

import type { MrphActivityDataRecord } from './mrph-activity-data-types.ts'
import { activitiesMrphActivityDataV1 } from './mrph-activity-data-v1.ts'
import { activitiesMrphActivityDataV2 } from './mrph-activity-data-v2.ts'

export const mrphProductVersions = [
  'product-fr-mrp-hiscox-1.0.0-2026-01-15',
  'product-fr-mrp-hiscox-2.0.0-2026-01-15',
  /**
   * Caps the contract start date for MRP products at 2 months for Orus-managed subscriptions.
   * Behaviour is otherwise identical to 2.0.0.
   */
  'product-fr-mrp-hiscox-2.1.0-2026-07-23',
] as const

export type MrphProductVersion = (typeof mrphProductVersions)[number]

/**
 * Activity data configuration by product version
 */
export const mrphActivityDataByProductVersion: Record<MrphProductVersion, MrphActivityDataRecord> = {
  'product-fr-mrp-hiscox-1.0.0-2026-01-15': activitiesMrphActivityDataV1,
  'product-fr-mrp-hiscox-2.0.0-2026-01-15': activitiesMrphActivityDataV2,
  'product-fr-mrp-hiscox-2.1.0-2026-07-23': activitiesMrphActivityDataV2,
}

export function getMrphActivityDataByProductVersion(
  mrphProductVersion: MrphProductVersion | null | undefined,
): MrphActivityDataRecord {
  if (!mrphProductVersion) throw new TechnicalError('mrphProductVersion is required')

  if (mrphProductVersion && mrphProductVersion in mrphActivityDataByProductVersion) {
    return mrphActivityDataByProductVersion[mrphProductVersion]
  }

  throw new TechnicalError('Invalid mrphProductVersion', {
    context: { mrphProductVersion, mrphActivityDataByProductVersion },
  })
}
